/* Package JSON Import will be here */
import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
/* Package JSON Import will be here */

/* Project Import will be here */
import createHistory from 'history/createBrowserHistory';
import rootReducer from './reducers';
import saga from '../src/middleware/sagas';
import { composeWithDevTools } from "redux-devtools-extension";
/* Project Import will be here */
let isTesting = false;
try
{
    let store = {};
    window.localStorage =  
        
        {
        get reduxState() {
            return store['reduxState'];
        },
        set reduxState(val) {
            store['reduxState'] = val;
        },
        getItem: key => store[key],
        setItem: (key, value) => { store[key] = value.toString(); },
        clear: () => { store = {}; }
        }; 
}
catch(ex){
    isTesting = true;
}
export const history = createHistory();
/* Const,Let & Var will be here */
const enhancers = [];
const middleware = [
    thunk,
    routerMiddleware(history)
];
// create the saga middleware
const sagaMiddleware = createSagaMiddleware();

/* Const,Let & Var will be here */


if (process.env.NODE_ENV === 'development') {
    const devToolsExtension = window.devToolsExtension;

    if (typeof devToolsExtension === 'function') {
        enhancers.push(devToolsExtension());
    }
}

const composedEnhancers = compose(
    applyMiddleware(...middleware),
    ...enhancers
);

const persistedState = isTesting ? 
window.localStorage.getItem('reduxState') ? JSON.parse(window.localStorage.getItem('reduxState')) : {} : 
localStorage.getItem('reduxState') ? JSON.parse(localStorage.getItem('reduxState')) : {};

export const store = createStore(
    rootReducer,
    persistedState,
    applyMiddleware(sagaMiddleware),
    composedEnhancers
    //composeWithDevTools(applyMiddleware(thunk, sagaMiddleware))
);

// then run the saga
sagaMiddleware.run(saga);

store.subscribe(() => {
    isTesting ? window.localStorage.setItem('reduxState', JSON.stringify(store.getState())) 
    : localStorage.setItem('reduxState', JSON.stringify(store.getState()));
});